import { render } from "./uni_table.vue?vue&type=template&id=7497a9d8"
import script from "./uni_table.vue?vue&type=script&lang=js"
export * from "./uni_table.vue?vue&type=script&lang=js"

import "./uni_table.vue?vue&type=style&index=0&id=7497a9d8&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__